import { createApi } from '@reduxjs/toolkit/query/react'

import baseQuery from './base-query.js'

/**
 * Rows carry `RuleFiringBatch` fields plus storage-only fields (`hostId`, `sk`,
 * `__expires__`). Left untyped here so callers narrow with
 * `ruleFiringBatchSchema.safeParse`, which strips the extras.
 */
export interface RuleFiringsResponse {
  items: Record<string, unknown>[]
  /** Present only when there are more pages; absent means "no more". Unused for now — the UI
   * shows the newest page only, see Task 7. */
  cursor?: string
}

// Define a service using a base URL and expected endpoints
export const rulesApi = createApi({
  reducerPath: 'rules-api',
  baseQuery,
  endpoints: builder => ({
    getRuleFirings: builder.query<RuleFiringsResponse, void>({
      query: () => ({
        url: `rules/firings`,
      }),
      keepUnusedDataFor: 60,
    }),
  }),
})
